var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Col, Row } from "@brushfire/ui";
import Number from "../../UI/Number";
var PaymentSummary = function (_a) {
    var _b;
    var eventData = _a.eventData, payload = _a.payload;
    var row = function (title, amount, isTotal, isDiscount) {
        if (isTotal === void 0) { isTotal = false; }
        if (isDiscount === void 0) { isDiscount = false; }
        return (_jsxs(Row, __assign({ className: "".concat(isTotal ? "m-top p-top b-top b-dashed" : "m-top-sm") }, { children: [_jsx(Col, __assign({ xs: 8 }, { children: _jsx("h6", __assign({ className: "".concat(isTotal ? "bold" : "").concat(isDiscount ? " success" : "") }, { children: title })) })), _jsx(Col, __assign({ xs: 4, className: "ta-right" }, { children: _jsx("h6", __assign({ className: "".concat(isTotal ? "bold" : "").concat(isDiscount ? " success" : "") }, { children: _jsx(Number, { value: amount !== null && amount !== void 0 ? amount : 0, style: "currency", currency: eventData.currency }) })) }))] })));
    };
    return (_jsxs("div", __assign({ className: "cart-summary-detail m-top" }, { children: [row("New Charge", payload.payload.attendeeTotal), !!payload.payload.taxTotal && _jsx(_Fragment, { children: row((_b = eventData.taxLabel) !== null && _b !== void 0 ? _b : "Taxes", payload.payload.taxTotal) }), !!payload.payload.feeTotal && _jsx(_Fragment, { children: row("Service Fees", payload.payload.feeTotal) }), _jsx(_Fragment, { children: row("Charge Total", payload.payload.total, true) })] })));
};
export default PaymentSummary;
